class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.form = this.querySelector('form');

    this.previousInputValue = this.input.value;

    this.clearButton = this.querySelector('[clear-search-term]');
    console.log("🚀 ~ PredictiveSearch ~ constructor ~ clearButton:", this.clearButton);

    this.clearButton.addEventListener('click', () => {
      this.input.value = '';
      this.classList.add('searching');
      this.getSearchResults('');
      this.updateClearButton();
      // this.classList.add('searching');
      // window.location.href = '/collections/all';
    });

    this.input.addEventListener('change', this.updateClearButton);

    this.input.addEventListener('focus', this.open);

    this.input.addEventListener('keyup', this.updateClearButton);

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    
    this.form.addEventListener('submit', (e) => {
      const searchTerm = this.input.value.trim();
      console.log("🚀 ~ PredictiveSearch ~ searchTerm:", searchTerm);

      if (searchTerm === '') {
        window.location.href = '/collections/all';
        e.stopPropagation();
        e.preventDefault();
      }

    });

    window.addEventListener('click', (e) => {
      if (e.target.closest('predictive-search') === null) {
        this.close();
      }
    });
  }

  updateClearButton = () => {
    console.log("🚀 ~ PredictiveSearch updateClearButton ~ this.input.value:", this.input.value);
    if (this.input.value === '') {
      this.classList.remove('dirty');
    } else if (this.input.value !== '') {
      this.classList.add('dirty');
    }

    this.previousInputValue = this.input.value;
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    this.updateClearButton();

    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.classList.add('searching');
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.predictiveSearchResults.innerHTML = '';
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      }).finally(() => {
        this.classList.remove('searching');
      });
  }

  open = () => {
    this.predictiveSearchResults.classList.add('is-active');
  }

  close = () => {
    this.predictiveSearchResults.classList.remove('is-active');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
